export function checkUrl(url: string): boolean {
    return url.startsWith('https') || url.startsWith('http');
  }